import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CurrencyPricePipe } from '@delon/util';

interface BillPreviewItem {
  accountCode: string;
  accountName: string;
  amount: number;
}

@Component({
  selector: 'app-transaction-preview-bill',
  standalone: true,
  imports: [CurrencyPricePipe, DecimalPipe],
  templateUrl: './transaction-preview-bill.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransactionPreviewBillComponent {
  @Input() currencyCode: string | null = null;
  @Input() items: BillPreviewItem[] | null = null;
  @Input() totalAmount: number | any = 0;
  @Input() taxableAmount: number | null = null;
  @Input() taxAmount: number | null = null;
  @Input() netTotal: number | null = null;
}
